const admy = {
  // ── SeoPage ──
  "admy.seo_keywords_ph": "Fjalëkyç1, Fjalëkyç2, Fjalëkyç3",

  // ── SocialPage placeholders ──
  "admy.eg_followers": "p.sh. 12.4k",
  "admy.eg_posts": "p.sh. 238",
  "admy.eg_likes": "p.sh. 48.6k",
  "admy.eg_shortcode": "p.sh. CxG7kPqLmN3",

  // ── TranslationsPage group names ──
  "admy.grp_nav": "Navigimi",
  "admy.grp_hero": "Ballina Hero",
  "admy.grp_services": "Shërbimet",
  "admy.grp_about": "Rreth nesh",
  "admy.grp_pricing": "Çmimet",
  "admy.grp_booking": "Rezervimi",
  "admy.grp_footer": "Footer",
  "admy.grp_gallery": "Galeria",
  "admy.grp_team": "Ekipi",
  "admy.grp_clinic": "Klinika",
  "admy.grp_process": "Procesi",
  "admy.grp_trust": "Besimi",
  "admy.grp_dental": "Dentare",
  "admy.grp_overview": "Përmbledhje",
  "admy.grp_implants": "Implantet",
  "admy.grp_contact": "Kontakti",
  "admy.grp_seo": "SEO",
  "admy.grp_admin": "Admin",
  "admy.grp_privacy": "Privatësia",
  "admy.grp_imprint": "Të dhënat ligjore",
  "admy.grp_agb": "Kushtet",
  "admy.grp_language": "Gjuhët",
  "admy.grp_service_detail": "Detajet e shërbimit",
  "admy.grp_instagram": "Instagram",

  // ── PageEditorPage field labels (home) ──
  "admy.f_hero_line1": "Hero — Rreshti 1",
  "admy.f_hero_line2": "Hero — Rreshti 2",
  "admy.f_hero_subtitle": "Hero — Nëntitulli",
  "admy.f_hero_cta": "Hero — Butoni CTA",
  "admy.f_services_tag": "Shërbimet — Etiketa",
  "admy.f_services_heading": "Shërbimet — Titulli",
  "admy.f_services_subtitle": "Shërbimet — Nëntitulli",
  "admy.f_hair_title": "Transplant flokësh — Titulli",
  "admy.f_hair_desc": "Transplant flokësh — Përshkrimi",
  "admy.f_dental_title": "Kozmetikë dentare — Titulli",
  "admy.f_dental_desc": "Kozmetikë dentare — Përshkrimi",
  "admy.f_botox_title": "Botox & filler — Titulli",
  "admy.f_botox_desc": "Botox & filler — Përshkrimi",
  "admy.f_services_cta": "Shërbimet — Teksti CTA",
  "admy.f_about_tag": "Rreth nesh — Etiketa",
  "admy.f_about_line1": "Rreth nesh — Rreshti 1",
  "admy.f_about_line2": "Rreth nesh — Rreshti 2",
  "admy.f_about_desc": "Rreth nesh — Përshkrimi",
  "admy.f_about_cta": "Rreth nesh — CTA",
  "admy.f_pricing_tag": "Çmimet — Etiketa",
  "admy.f_pricing_line1": "Çmimet — Rreshti 1",
  "admy.f_pricing_line2": "Çmimet — Rreshti 2",
  "admy.f_pricing_subtitle": "Çmimet — Nëntitulli",
  "admy.f_pricing_cta": "Çmimet — CTA",
  "admy.f_testimonials_tag": "Vlerësimet — Etiketa",
  "admy.f_testimonials_heading": "Vlerësimet — Titulli",
  "admy.f_testimonials_subtitle": "Vlerësimet — Nëntitulli",
  "admy.f_testimonial1_text": "Vlerësimi 1 — Teksti",
  "admy.f_testimonial1_name": "Vlerësimi 1 — Emri",
  "admy.f_testimonial1_role": "Vlerësimi 1 — Roli",
  "admy.f_testimonial2_text": "Vlerësimi 2 — Teksti",
  "admy.f_testimonial2_name": "Vlerësimi 2 — Emri",
  "admy.f_testimonial2_role": "Vlerësimi 2 — Roli",
  "admy.f_testimonial3_text": "Vlerësimi 3 — Teksti",
  "admy.f_testimonial3_name": "Vlerësimi 3 — Emri",
  "admy.f_testimonial3_role": "Vlerësimi 3 — Roli",
  "admy.f_testimonial4_text": "Vlerësimi 4 — Teksti",
  "admy.f_testimonial4_name": "Vlerësimi 4 — Emri",
  "admy.f_testimonial4_role": "Vlerësimi 4 — Roli",
  "admy.f_testimonial5_text": "Vlerësimi 5 — Teksti",
  "admy.f_testimonial5_name": "Vlerësimi 5 — Emri",
  "admy.f_testimonial5_role": "Vlerësimi 5 — Roli",
  "admy.f_booking_tag": "Rezervimi — Etiketa",
  "admy.f_booking_line1": "Rezervimi — Rreshti 1",
  "admy.f_booking_line2": "Rezervimi — Rreshti 2",
  "admy.f_booking_desc": "Rezervimi — Përshkrimi",
  "admy.f_booking_cta": "Rezervimi — CTA",
  "admy.f_process_tag": "Procesi — Etiketa",
  "admy.f_process_heading": "Procesi — Titulli",
  "admy.f_process_subtitle": "Procesi — Nëntitulli",
  "admy.f_trust_tag": "Besimi — Etiketa",
  "admy.f_trust_heading": "Besimi — Titulli",
  "admy.f_trust_subtitle": "Besimi — Nëntitulli",
  "admy.f_instagram_heading": "Instagram — Titulli",
  "admy.f_instagram_cta": "Instagram — CTA",
  "admy.f_footer_company": "Footer — Emri i kompanisë",
  "admy.f_footer_address": "Footer — Adresa",
  "admy.f_footer_phone": "Footer — Telefoni",
  "admy.f_footer_email": "Footer — E-mail",
  "admy.f_img_hero_bg": "Imazhi — Sfondi Hero",
  "admy.f_img_hair": "Imazhi — Transplant flokësh",
  "admy.f_img_dental": "Imazhi — Kozmetikë dentare",
  "admy.f_img_botox": "Imazhi — Botox & filler",
  "admy.f_img_about_team": "Imazhi — Ekipi Rreth nesh",
  "admy.f_img_cta_bg": "Imazhi — Sfondi CTA",
  "admy.f_img_process_bg": "Imazhi — Sfondi Procesi",
  "admy.f_img_trust_bg": "Imazhi — Sfondi Besimi",
  "admy.f_img_instagram_1": "Imazhi — Instagram 1",
  "admy.f_img_instagram_2": "Imazhi — Instagram 2",
  "admy.f_img_instagram_3": "Imazhi — Instagram 3",
  "admy.f_img_instagram_4": "Imazhi — Instagram 4",

  // ── shared / about ──
  "admy.f_tag": "Etiketa",
  "admy.f_headline_line1": "Titulli Rreshti 1",
  "admy.f_headline_line2": "Titulli Rreshti 2",
  "admy.f_description": "Përshkrimi",
  "admy.f_quote": "Citimi",
  "admy.f_name": "Emri",
  "admy.f_position": "Pozicioni",
  "admy.f_mission_title": "Misioni — Titulli",
  "admy.f_mission_text": "Misioni — Teksti",
  "admy.f_values_title": "Vlerat — Titulli",
  "admy.f_values_text": "Vlerat — Teksti",
  "admy.f_why_albania_title": "Pse Shqipëria — Titulli",
  "admy.f_why_albania_text": "Pse Shqipëria — Teksti",
  "admy.f_cta_heading": "CTA — Titulli",
  "admy.f_cta_subtitle": "CTA — Nëntitulli",
  "admy.f_cta_button": "CTA — Butoni",
  "admy.f_img_hero_bg_tirana": "Imazhi — Sfondi Hero (Tirana)",
  "admy.f_img_doctor": "Imazhi — Foto Ekipi/Mjeku",
  "admy.f_img_mission": "Imazhi — Misioni",
  "admy.f_img_clinic": "Imazhi — Klinika",

  // ── services ──
  "admy.f_headline": "Titulli",
  "admy.f_subtitle": "Nëntitulli",
  "admy.f_hair_text": "Transplant flokësh — Teksti",
  "admy.f_hair_price": "Transplant flokësh — Çmimi",
  "admy.f_dental2_title": "Dentare — Titulli",
  "admy.f_dental2_text": "Dentare — Teksti",
  "admy.f_dental2_price": "Dentare — Çmimi",
  "admy.f_botox2_title": "Botox — Titulli",
  "admy.f_botox2_text": "Botox — Teksti",
  "admy.f_botox2_price": "Botox — Çmimi",
  "admy.f_surgery_title": "Kirurgji — Titulli",
  "admy.f_surgery_text": "Kirurgji — Teksti",
  "admy.f_surgery_price": "Kirurgji — Çmimi",
  "admy.f_cta_text": "Teksti CTA",
  "admy.f_cta_subtitle2": "Nëntitulli CTA",
  "admy.f_img_dental2": "Imazhi — Dentare",
  "admy.f_img_botox2": "Imazhi — Botox",
  "admy.f_img_surgery": "Imazhi — Kirurgji",

  // ── pricing ──
  "admy.f_essential_title": "Essential — Titulli",
  "admy.f_essential_price": "Essential — Çmimi",
  "admy.f_essential_desc": "Essential — Përshkrimi",
  "admy.f_essential_features": "Essential — Veçoritë (ndara me presje)",
  "admy.f_premium_title": "Premium — Titulli",
  "admy.f_premium_price": "Premium — Çmimi",
  "admy.f_premium_desc": "Premium — Përshkrimi",
  "admy.f_premium_features": "Premium — Veçoritë (ndara me presje)",
  "admy.f_luxe_title": "Luxe — Titulli",
  "admy.f_luxe_price": "Luxe — Çmimi",
  "admy.f_luxe_desc": "Luxe — Përshkrimi",
  "admy.f_luxe_features": "Luxe — Veçoritë (ndara me presje)",
  "admy.f_exclusif_title": "Exclusif — Titulli",
  "admy.f_exclusif_price": "Exclusif — Çmimi",
  "admy.f_exclusif_desc": "Exclusif — Përshkrimi",
  "admy.f_exclusif_features": "Exclusif — Veçoritë (ndara me presje)",
  "admy.f_guarantee_text": "Teksti i garancisë",
  "admy.f_img_essential": "Imazhi — Paketa Essential",
  "admy.f_img_premium": "Imazhi — Paketa Premium",
  "admy.f_img_luxe": "Imazhi — Paketa Luxe",
  "admy.f_img_exclusif": "Imazhi — Paketa Exclusif",

  // ── booking ──
  "admy.f_hero_subtitle2": "Nëntitulli Hero",
  "admy.f_form_title": "Formulari — Titulli",
  "admy.f_form_subtitle": "Formulari — Nëntitulli",
  "admy.f_form_firstname": "Formulari — Etiketa Emri",
  "admy.f_form_lastname": "Formulari — Etiketa Mbiemri",
  "admy.f_form_email": "Formulari — Etiketa E-mail",
  "admy.f_form_phone": "Formulari — Etiketa Telefoni",
  "admy.f_form_service": "Formulari — Etiketa Trajtimi",
  "admy.f_form_message": "Formulari — Etiketa Mesazhi",
  "admy.f_form_privacy": "Formulari — Teksti Privatësia",
  "admy.f_success_title": "Sukses — Titulli",
  "admy.f_success_message": "Sukses — Mesazhi",
  "admy.f_contact_tag": "Kontakti — Etiketa",
  "admy.f_contact_heading": "Kontakti — Titulli",
  "admy.f_contact_subtitle": "Kontakti — Nëntitulli",

  // ── team ──
  "admy.f_cta_headline": "Titulli CTA",
  "admy.f_cta_subtitle3": "Nëntitulli CTA",
  "admy.f_cta_button2": "Butoni CTA",
  "admy.f_show_more": "Shfaq më shumë",
  "admy.f_show_less": "Shfaq më pak",

  // ── gallery ──
  "admy.f_filter_all": "Filtri — Të gjitha",
  "admy.f_filter_dental": "Filtri — Dentare",
  "admy.f_filter_surgery": "Filtri — Kirurgji",
  "admy.f_filter_hair": "Filtri — Flokë",
  "admy.f_filter_aesthetic": "Filtri — Estetikë",
  "admy.f_before_label": "Etiketa Para",
  "admy.f_after_label": "Etiketa Pas",
};

export default admy;
